import { render, staticRenderFns } from "./TableSettlement.vue?vue&type=template&id=a4e6df70&scoped=true"
import script from "./TableSettlement.vue?vue&type=script&lang=js"
export * from "./TableSettlement.vue?vue&type=script&lang=js"
import style0 from "./TableSettlement.vue?vue&type=style&index=0&id=a4e6df70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e6df70",
  null
  
)

export default component.exports